import { useSyncExternalStore } from "react";
export const useEngineState = (engine) => useSyncExternalStore((listener) => engine.subscribe(listener), () => engine.getState(), () => engine.getState());
//# sourceMappingURL=useEngineState.js.map